var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalUserCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2318 1.14326C14.5897 1.83063 12.196 3.84551 11.0053 6.38448C10.637 7.16985 10.2597 8.22552 10.1669 8.73035C9.23897 13.7778 12.1813 20.0927 16.4618 22.2407C17.5123 22.7677 17.7174 22.8103 19.189 22.8057C20.6188 22.8013 20.8908 22.7471 21.8671 22.2718C23.9224 21.2711 25.6247 19.4473 26.8765 16.9049C29.2458 12.0927 28.7847 7.04611 25.6815 3.82472C24.7091 2.81506 23.2497 1.86761 21.9879 1.42636C20.6738 0.966864 18.4244 0.832902 17.2318 1.14326ZM9.58016 22.5404C5.93337 24.04 3.01192 25.7219 1.98768 26.9113C1.43585 27.552 0.536147 30.1985 0.363127 31.6898C0.169211 33.3609 1.39523 34.8384 4.03031 36.109C11.911 39.9089 27.4786 39.8121 34.7473 35.918C37.3337 34.5323 38.7941 32.4362 38.0922 31.117C38.0056 30.9542 37.7249 30.137 37.4685 29.301C36.9312 27.5498 36.4003 26.7201 35.2827 25.8857C34.2516 25.116 30.2812 23.1001 28.0886 22.2334L26.3698 21.5537L25.3847 22.45C21.8723 25.6452 17.0628 25.8049 13.4894 22.8449C11.7706 21.4211 12.2171 21.4561 9.58016 22.5404ZM0.347748 32.0994C0.347748 32.5212 0.380345 32.6939 0.420299 32.4829C0.460085 32.2719 0.460085 31.9269 0.420299 31.7159C0.380345 31.5049 0.347748 31.6776 0.347748 32.0994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUserCard);
export default __webpack_public_path__ + "static/media/totalUserCard.b65d3c0f8976bbf0a7fa54a22e5b1029.svg";
export { ForwardRef as ReactComponent };